import { toggleValues } from 'platform/site-wide/feature-toggles/selectors';
import { TOGGLE_NAMES } from 'platform/utilities/feature-toggles';

const ADDRESS_KEYS = [
  'street',
  'street2',
  'street3',
  'city',
  'state',
  'postalCode',
  'country',
  'isMilitary',
];

const sanitizeAddress = address => {
  if (!address) return undefined;
  const entries = ADDRESS_KEYS.filter(
    key => ![undefined, null, ''].includes(address[key]),
  ).map(key => [key, address[key]]);
  return entries.length ? Object.fromEntries(entries) : undefined;
};

const sanitizePhone = phone => phone?.replace(/\D/g, '') || undefined;

const sanitizeEmail = email => email?.trim() || undefined;

const sanitizeRating = rating =>
  Number.isInteger(rating) && rating >= 0 && rating <= 100 ? rating : undefined;

const sanitizeBoolean = value =>
  typeof value === 'boolean' ? value : undefined;

// Staged under a view: key because the certifier role is unknown at prefill time
const prefillTransformer = (pages, formData, metadata, state) => {
  const { veteran, ...existingFormData } = formData || {};
  const prefillEnabled =
    toggleValues(state)[TOGGLE_NAMES.form1010dPrefillEnabled];

  if (!prefillEnabled || !veteran) {
    return { pages, metadata, formData: existingFormData };
  }

  const {
    fullName = {},
    dateOfBirth,
    ssnOrTin,
    address,
    phoneNumber,
    email,
    combinedRating,
    permanentAndTotal,
  } = veteran;

  return {
    pages,
    metadata,
    formData: {
      ...existingFormData,
      'view:profilePrefill': {
        fullName: {
          first: fullName.first,
          middle: fullName.middle?.charAt(0) || undefined,
          last: fullName.last,
          suffix: fullName.suffix,
        },
        dateOfBirth,
        ssn: ssnOrTin,
        address: sanitizeAddress(address),
        phone: sanitizePhone(phoneNumber),
        email: sanitizeEmail(email),
        disabilityRating: sanitizeRating(combinedRating),
        permanentAndTotal: sanitizeBoolean(permanentAndTotal),
      },
    },
  };
};

export default prefillTransformer;
